module.exports = __webpack_public_path__ + "static/img/DE.1c675503.svg";